import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const forecastData = [
  { category: "BOARDS", swell: "4-6 FT", condition: "Glassy", icon: "Navigation", link: "#boards" },
  { category: "WETSUITS", swell: "58° F", condition: "Chilly", icon: "Droplet", link: "#wetsuits" },
  { category: "APPAREL", swell: "SUNNY", condition: "Offshore", icon: "Sun", link: "#apparel" },
  { category: "ACCESSORIES", swell: "ESSENTIAL", condition: "Stocked", icon: "Tool", link: "#accessories" },
];

export const Forecast = () => {
  return (
    <section className="py-12 bg-[#0a192f] relative z-20 -mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {forecastData.map((item, index) => (
            <motion.a 
              href={item.link}
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gradient-to-br from-[#0f294d] to-[#0a192f] border border-gray-800 rounded-2xl p-6 hover:border-[#93e9be] transition-colors group cursor-pointer"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="text-[#93e9be] font-mono text-sm tracking-widest">
                  REPORT // {item.category}
                </div>
                <SafeIcon name={item.icon} className="h-6 w-6 text-[#ff7f50] opacity-80 group-hover:opacity-100 transition-opacity" />
              </div>
              
              <div className="mb-2">
                <span className="text-3xl font-black text-white">{item.swell}</span>
              </div>
              
              <div className="flex items-center text-gray-400 text-sm">
                <SafeIcon name="Activity" className="h-4 w-4 mr-2" />
                Condition: <span className="text-white ml-1 font-medium">{item.condition}</span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};